import { Accordion, Text } from '@mantine/core';
import classes from './SubscriptionInfo.module.scss';
import { Actions, trackAction } from 'utils/amplitude';
import { CaretDown, Info } from '@phosphor-icons/react';

interface ISubscriptionInfoProps {
  info: string;
}

const SubscriptionInfo: React.FC<ISubscriptionInfoProps> = ({ info }) => {
  return (
    <Accordion
      variant="contained"
      radius={0}
      classNames={{
        item: classes.accordionItem,
        control: classes.accordionControl,
        panel: classes.accordionPanel,
      }}
      chevron={<CaretDown size={22} weight="bold" />}
      onClick={() => trackAction(Actions.ADP_SUB_DETAILS)}
    >
      <Accordion.Item value="info">
        <Accordion.Control icon={<Info size={26} />}>
          <Text style={{ fontWeight: 700 }}>Subscription details</Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Text className={classes.accordionContent} dangerouslySetInnerHTML={{ __html: info }} />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default SubscriptionInfo;
